import { call, take, put } from 'redux-saga/effects';
import { get, putMethod, post } from '../../utils/api';
import { get as getLodash, includes, isEmpty } from '../../utils/lodash';
import {getTrainingDashboardTokenFromCookies} from '../../utils/helper';
import settings from '../../utils/settings';
import {
  ACCOUNT_DETAIL_REQUEST,
  ACCOUNT_DETAIL_SUCCESS,
  UPDATE_ACCOUNT_SUCCESS,
  REQUEST_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESEND_CONFIRMATION_EMAIL_REQUEST,
  RESEND_CONFIRMATION_EMAIL_SUCCESS,
  CANCEL_EMAIL_CHANGE_REQUEST,
  CANCEL_EMAIL_CHANGE_SUCCESS,
  REQUEST_TRAINING_DASHBOARD_TOKEN,
  SET_TRAINING_DASHBOARD_TOKEN,
  GENERATE_API_KEY_REQUEST,
  GENERATE_API_KEY_SUCCESS,
  GENERATE_API_KEY_FAILURE,
  GET_API_KEY_REQUEST,
  GET_API_KEY_SUCCESS,
  GET_FLEET_DASHBOARD_LINK,
  SET_FLEET_DASHBOARD_LINK,
  GET_JOB_PROFILE_REQUEST,
  GET_JOB_PROFILE_SUCCESS
} from './constants';
import { SET_COUNTRY, SET_ITK } from '../Layouts/constants';
import queryString from 'query-string';
import { getBelongsTo } from '../../utils/helper';

export function* getAccountData() {
  while (true) {
    const request = yield take(ACCOUNT_DETAIL_REQUEST);
    const {
      body = {},
      isUpdate = false,
      successCbk = () => {},
      failureCbk = () => {},
      hideSnakbar = false,
      setCountry = true
    } = request.payload;
    try {
      let response;
      if (isUpdate) {
        response = yield call(putMethod, {
          url: settings.getApiUrl(`service/enlm_ms/api_internal/account`),
          body
        });
      } else {
        response = yield call(get, {
          url: settings.getApiUrl(`service/enlm_ms/api_internal/account`)
        });
      }
      const { success, result, isUnauthorized } = response;
      if (success) {
        if (isUpdate) {
          yield put({ type: UPDATE_ACCOUNT_SUCCESS, message: result.message, hideSnakbar: hideSnakbar });
          successCbk();
        } else {
          const details = response.result;
          const isLoginAs = getLodash(details, 'login_as', false);
          const roles = getLodash(details, 'roles', []);
          let viewOnlyRole = roles.find(role => role === 'support_read');
          let viewCannotEdit = false;
          const { search } = window.location;
          const { platform = '' } = queryString.parse(search);
          if (isEmpty(viewOnlyRole) && isLoginAs) {
            const parentUserRoles = getLodash(details, 'login_user.roles', []);
            viewOnlyRole = parentUserRoles.find(role => role === 'support_read');
            if (!isEmpty(viewOnlyRole)) {
              viewCannotEdit = true;
            }
          }
          const belongsToList = getBelongsTo(details.country);
          if (setCountry) {
            yield put({
              type: SET_COUNTRY,
              ...belongsToList
            });
          }
          yield put({
            type: ACCOUNT_DETAIL_SUCCESS,
            accountDetail: details,
            viewOnlyAccess: !isEmpty(viewOnlyRole),
            viewCannotEdit
          });
          yield put({
            type: SET_ITK,
            fromITK: !isEmpty(search) ? platform === 'itk' : includes(window.location.href, 'platform=itk')
          });
          successCbk();
        }
      } else {
        yield put({ type: REQUEST_FAILURE, error: result.message || result.messages, isUnauthorized });
        failureCbk();
      }
    } catch (error) {
      yield put({ type: REQUEST_FAILURE, error });
      failureCbk();
    }
  }
}

export function* resetPassword() {
  while (true) {
    const request = yield take(RESET_PASSWORD_REQUEST);
    const { body = {} } = request.payload;
    try {
      let response;
      response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/account/reset-password`),
        body
      });
      const { success, result } = response;
      if (success) {
        yield put({ type: RESET_PASSWORD_SUCCESS, message: result.message });
      } else {
        yield put({ type: REQUEST_FAILURE, error: result.message || result.messages });
      }
    } catch (error) {
      yield put({ type: REQUEST_FAILURE, error });
    }
  }
}

export function* resendConfirmationEmailFlow() {
  while (true) {
    const request = yield take(RESEND_CONFIRMATION_EMAIL_REQUEST);
    const { successCbk = () => {} } = request.payload;
    try {
      let response;
      response = yield call(putMethod, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/account/resend_email_change`)
      });
      const { success, result } = response;
      if (success) {
        yield put({ type: RESEND_CONFIRMATION_EMAIL_SUCCESS, message: result.message });
        successCbk();
      } else {
        yield put({ type: REQUEST_FAILURE, error: result.message || result.messages });
      }
    } catch (error) {
      yield put({ type: REQUEST_FAILURE, error });
    }
  }
}

export function* cancelEmailChangeFlow() {
  while (true) {
    const request = yield take(CANCEL_EMAIL_CHANGE_REQUEST);
    const { successCbk = () => {} } = request.payload;
    try {
      let response;
      response = yield call(putMethod, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/account/cancel_email_change`)
      });
      const { success, result } = response;
      if (success) {
        yield put({ type: CANCEL_EMAIL_CHANGE_SUCCESS, message: result.message });
        successCbk();
      } else {
        yield put({ type: REQUEST_FAILURE, error: result.message || result.messages });
      }
    } catch (error) {
      yield put({ type: REQUEST_FAILURE, error });
    }
  }
}

export function* getTrainingDashboardToken() {
  while (true) {
    const request = yield take(REQUEST_TRAINING_DASHBOARD_TOKEN);
    try {
      let response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/account/training_dashboard_token`)
      });
      const { success, result } = response;
      const tokenFromCookies = getTrainingDashboardTokenFromCookies();
      if (success) {
        const token = result.token;
        yield put({
          type: SET_TRAINING_DASHBOARD_TOKEN,
          payload: tokenFromCookies
        });
        // successCbk();
      } else {
        yield put({ type: SET_TRAINING_DASHBOARD_TOKEN, payload: null });
      }
    } catch (error) {
      yield put({ type: SET_TRAINING_DASHBOARD_TOKEN, payload: null });
    }
  }
}

export function* getFleetDashboardLinkFlow() {
  while (true) {
    const request = yield take(GET_FLEET_DASHBOARD_LINK);
    // const { successCbk, failureCbk } = request;
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl('service/enlm_ms/api_internal/account/fleet_dashboard_url')
      });
      const { success, status, result } = response;
      if (success && status === 200) {
        yield put({
          type: SET_FLEET_DASHBOARD_LINK,
          payload: result.url
        });
        // successCbk(result);
      } else {
        // failureCbk();
        yield put({ type: SET_FLEET_DASHBOARD_LINK, payload: null });
      }
    } catch (error) {
      // failureCbk();
        yield put({ type: SET_FLEET_DASHBOARD_LINK, payload: null });
    }
  }
}

export function* generateApiKeyFlow() {
  while (true) {
    const request = yield take(GENERATE_API_KEY_REQUEST);
    const { installerId } = request.payload;
    try {
      let response;
      response = yield call(post, {
        url: settings.digiCoreUrl(`installers/${installerId}/generate_api_key`),
        withBearer: true
      });
      const { success, result } = response;
      if (success) {
        yield put({ type: GENERATE_API_KEY_SUCCESS, apiKey: result.api_key });
      } else {
        yield put({ type: GENERATE_API_KEY_FAILURE, error: result.message || result.messages });
      }
    } catch (error) {
      yield put({ type: GENERATE_API_KEY_FAILURE, error });
    }
  }
}

export function* getApiKeyFlow() {
  while (true) {
    const request = yield take(GET_API_KEY_REQUEST);
    const { installerId } = request.payload;
    try {
      let response;
      response = yield call(get, {
        url: settings.digiCoreUrl(`installers/${installerId}/get_api_key`),
        withBearer: true
      });
      const { success, result } = response;
      if (success) {
        yield put({ type: GET_API_KEY_SUCCESS, apiKey: result.api_key });
      }
    } catch (error) {}
  }
}

export function* getJobProfileList(){
  while (true) {
  const request = yield take(GET_JOB_PROFILE_REQUEST);
  try {
    let response;
    response = yield call(get, {
      url: settings.getApiUrl(`service/enlm_ms/api_internal/job_profile_list?locale=${request.payload.locale}`)
    });
    const { success, result } = response;
    if (success) {
      yield put({ type: GET_JOB_PROFILE_SUCCESS, job_profile_list: result.list, show_job_profile: result.show_job_profile });
      }
    } catch (error) {}
  }
}
